import { render, staticRenderFns } from "./ConfirmRecharge.vue?vue&type=template&id=2f9e0f72&scoped=true"
import script from "./ConfirmRecharge.vue?vue&type=script&lang=js"
export * from "./ConfirmRecharge.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRecharge.vue?vue&type=style&index=0&id=2f9e0f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e0f72",
  null
  
)

export default component.exports